import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

const SubHeader = () => {
  return (
    <Navbar className="container" color="light" light expand="md">
      <NavbarBrand className="brand" href="/">
        Ravi Kishan
      </NavbarBrand>
      <NavbarToggler />
      <Collapse navbar>
        <Nav className="ml-auto" navbar>
          <NavItem>
            <NavLink className="temp" href="/">
              HOME
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className="temp" href="#">
              ABOUT
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className="temp" href="#">
              SKILLS
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className="temp" href="#12">
              PROJECTS
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className="temp" href="#12">
              BLOGS
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className="temp" href="#22">
              RESUME
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className="temp" href="76">
              CONTACT ME
            </NavLink>
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default SubHeader;
